import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AttributeServiceConfig = {
  name: "Attribute",
  annotations: []
} as ServiceConfig;